import { call, put, takeLatest, delay } from "redux-saga/effects";
import { bienLaiThuApi } from "../../../api/bien-lai/bienLaiThuApi";
import { IBienLaiHuyRequest } from "../../../model/request/bien-lai/IBienLaiHuyRequest";
import { IBienLaiPagingRequest } from "../../../model/request/bien-lai/IBienLaiPagingRequest";
import { IBienLaiThu } from "../../../model/respone/bien-lai/IBienLaiThu";
import { IPagingBienLaiResult } from "../../../model/respone/bien-lai/IBienLaiThuPaging";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import {
  eBienLaiPagingActionTypeIds,
  IBienLaiPagingActionTypes,
} from "./../../action-types/bien-lai/IBienLaiPagingActionTypes";
import { IBienLaiChangeChoPhepXuatHDRequest } from "../../../model/request/bien-lai/IBienLaiChangeChoPhepXuatHDRequest";
import { IBienLaiSyncKeToanRequest } from "../../../model/request/bien-lai/IBienLaiSyncKeToanRequest";
import { IBienLaiSaveImportRequest } from "../../../model/request/bien-lai/IBienLaiSaveImportRequest";

export function* bienLaiPagingSaga(): any {
  yield takeLatest(eBienLaiPagingActionTypeIds.LOAD_START, loadWorker);
  yield takeLatest(eBienLaiPagingActionTypeIds.HUY_START, huyWorker);
  yield takeLatest(
    eBienLaiPagingActionTypeIds.CHANGE_CHO_PHEP_XUAT_HD_START,
    changeChoPhepXuatHoaDonWorker,
  );
  yield takeLatest(
    eBienLaiPagingActionTypeIds.EXPORT_EXCEL_BAO_CAO_START,
    exportExcelWorker,
  );
  yield takeLatest(
    eBienLaiPagingActionTypeIds.PRINT_BAO_CAO_START,
    printWorker,
  );
  yield takeLatest(
    eBienLaiPagingActionTypeIds.SYNC_KE_TOAN_START,
    syncKeToanWorker,
  );
  yield takeLatest(
    eBienLaiPagingActionTypeIds.SYNC_KE_TOAN_FAKE_START,
    syncKeToanFakeWorker,
  );
  yield takeLatest(eBienLaiPagingActionTypeIds.IMPORT_START, importStart);
  yield takeLatest(
    eBienLaiPagingActionTypeIds.SAVE_IMPORT_START,
    saveImportStart,
  );
}

function* loadWorker(action: IBienLaiPagingActionTypes): any {
  const request = action.payload as IBienLaiPagingRequest;
  const res: IBaseRespone = yield call(bienLaiThuApi.SelectPaging, request);
  if (res.is_success) {
    var data = res.data as IPagingBienLaiResult;
    yield put(rootActions.bienLai.bienLaiPaging.LOAD_SUCCESS(data));
  } else {
    yield put(
      rootActions.bienLai.bienLaiPaging.LOAD_ERRR(res.message ?? "Có lỗi"),
    );
  }
}

function* huyWorker(action: IBienLaiPagingActionTypes): any {
  const request = action.payload as IBienLaiHuyRequest;
  const res: IBaseRespone = yield call(bienLaiThuApi.Huy, request);
  if (res.is_success) {
    var data = res.data as IBienLaiThu;
    yield put(rootActions.bienLai.bienLaiPaging.HUY_SUCCESS(data));
    yield put(
      rootActions.bienLai.bienLaiView.LOAD_START({
        hoc_ky: data.hoc_ky,
        id_sv: data.id_sv,
        nam_hoc: data.nam_hoc,
      }),
    );
    // Bảng biên lai NGUỒN (BienLaiTableSinhVien) khi bật config "tất cả học kỳ" dùng cache key (0, "")
    // → reload thêm key này để "đã chi / còn lại" của biên lai nguồn cập nhật sau khi hủy phiếu chi.
    // (saga dùng takeEvery nên 2 lượt LOAD_START không hủy nhau.)
    if (data.hoc_ky !== 0 || (data.nam_hoc ?? "") !== "") {
      yield put(
        rootActions.bienLai.bienLaiView.LOAD_START({
          hoc_ky: 0,
          id_sv: data.id_sv,
          nam_hoc: "",
        }),
      );
    }
    yield put(
      rootActions.bienLai.bienLaiViewChiTiet.LOAD_START(data.id_bien_lai),
    );
  } else {
    yield put(
      rootActions.bienLai.bienLaiPaging.HUY_ERRR(res.message ?? "Có lỗi"),
    );
  }
}

function* changeChoPhepXuatHoaDonWorker(
  action: IBienLaiPagingActionTypes,
): any {
  const request = action.payload as IBienLaiChangeChoPhepXuatHDRequest;
  const res: IBaseRespone = yield call(
    bienLaiThuApi.ChangeChoPhepXuatHoaDon,
    request,
  );
  if (res.is_success) {
    var data = res.data as IBienLaiChangeChoPhepXuatHDRequest;
    yield put(
      rootActions.bienLai.bienLaiPaging.CHANGE_CHO_PHEP_XUAT_HD_SUCCESS(data),
    );
  } else {
    yield put(
      rootActions.bienLai.bienLaiPaging.CHANGE_CHO_PHEP_XUAT_HD_ERRR(
        res.message ?? "Có lỗi",
      ),
    );
  }
}

function* exportExcelWorker(action: IBienLaiPagingActionTypes): any {
  const request = action.payload as IBienLaiPagingRequest;
  const res: IBaseRespone = yield call(bienLaiThuApi.ExportExcel, request);
  if (res.is_success) {
    yield put(
      rootActions.bienLai.bienLaiPaging.EXPORT_EXCEL_BAO_CAO_SUCCESS(res.data),
    );
  } else {
    yield put(
      rootActions.bienLai.bienLaiPaging.EXPORT_EXCEL_BAO_CAO_ERRR(
        res?.message ?? "Thất bại",
      ),
    );
  }
}

function* printWorker(action: IBienLaiPagingActionTypes): any {
  const request = action.payload as IBienLaiPagingRequest;
  const res: IBaseRespone = yield call(bienLaiThuApi.Print, request);
  if (res.is_success) {
    yield put(
      rootActions.bienLai.bienLaiPaging.PRINT_BAO_CAO_SUCCESS(res.data),
    );
  } else {
    yield put(
      rootActions.bienLai.bienLaiPaging.PRINT_BAO_CAO_ERRR(
        res?.message ?? "Thất bại",
      ),
    );
  }
}

function* syncKeToanWorker(action: IBienLaiPagingActionTypes): any {
  const request = action.payload as IBienLaiSyncKeToanRequest;
  const api = bienLaiThuApi.SyncKeToanFast;

  const res: IBaseRespone = yield call(api, request.id_bien_lais);
  if (res.is_success) {
    yield put(
      rootActions.bienLai.bienLaiPaging.SYNC_KE_TOAN_SUCCESS(undefined),
    );
  } else {
    yield put(
      rootActions.bienLai.bienLaiPaging.SYNC_KE_TOAN_ERRR(
        res?.message ?? "Thất bại",
      ),
    );
  }
}

function* syncKeToanFakeWorker(action: IBienLaiPagingActionTypes): any {
  yield delay(5000);
  yield put(rootActions.bienLai.bienLaiPaging.SYNC_KE_TOAN_SUCCESS(undefined));
}

function* importStart(action: IBienLaiPagingActionTypes): any {
  const res: IBaseRespone = yield call(
    bienLaiThuApi.Import,
    action.payload as FormData,
  );
  if (res.is_success) {
    console.log(res.data);
    yield put(rootActions.bienLai.bienLaiPaging.IMPORT_SUCESS(res.data));
  } else {
    yield put(
      rootActions.bienLai.bienLaiPaging.IMPORT_ERROR(res.message ?? "Có lỗi"),
    );
  }
}

function* saveImportStart(action: IBienLaiPagingActionTypes): any {
  const res: IBaseRespone = yield call(
    bienLaiThuApi.SaveImport,
    action.payload as IBienLaiSaveImportRequest,
  );
  if (res.is_success) {
    yield put(rootActions.bienLai.bienLaiPaging.SAVE_IMPORT_SUCESS(res.data));
  } else {
    yield put(
      rootActions.bienLai.bienLaiPaging.SAVE_IMPORT_ERROR(
        res.message ?? "Có lỗi",
      ),
    );
  }
}
